export default {
    jsonToDomSetter: {
        title: 'JSON选择器',
        expression: '表达式',
        expressionTip: '请在下方选择一个节点',
        arrayInputKey: '输入',
        confirm: '确定',
        cancel: '取消',
    }
}